import {
  constant,
  curryN,
  every,
  filter,
  flow,
  identity,
  includes,
  keys,
  orderBy,
  placeholder,
  rest,
  size,
  some,
  times,
  where
} from 'lodash/fp';

const restArgs = curryN(2, flow)(rest(identity));

const logicalOr = restArgs(some(identity));
const logicalAnd = restArgs(every(identity));

const objectSize = flow(
  keys,
  size
);

export function filterByPropValues(propKey, vals = []) {
  if (!propKey) {
    return identity;
  }

  return filter(
    where({
      [propKey]: includes(placeholder, vals)
    })
  );
}

function orderByDesc(sortKey) {
  if (Array.isArray(sortKey)) {
    return orderBy(sortKey, times(constant('desc'), sortKey.length));
  }
  return orderBy(sortKey, 'desc');
}

function posNegZero(positiveValue, negativeValue, zeroValue) {
  return x => {
    if (typeof x !== 'number' || x === 0) {
      return zeroValue;
    }

    return x > 0 ? positiveValue : negativeValue;
  };
}

export { logicalAnd, logicalOr, objectSize, orderByDesc, restArgs, posNegZero };
